import Vue from 'vue';
import HomePage from '@/pages/home/Home.vue';
import AccessDeniedPage from '@/pages/denied/AccessDenied.vue';
import ErrorPage from '@/pages/error/Error.vue';
import InitCompanyPage from '@/pages/init/InitCompany.vue';
import PermissionPage from '@/pages/permission/Permission.vue';
import FinancialPage from '@/pages/financial/Financial.vue';
import LegalPage from '@/pages/legal/Legal.vue';
import MarketplacePage from '@/pages/marketplace/Marketplace.vue';
import ProfilePage from '@/pages/profile/Profile.vue';
import ShareholderPage from '@/pages/shareholder/Shareholder.vue';
import VotingPage from '@/pages/voting/Voting.vue';
import CustomRouter from '@/helpers/Router';
import NotificationPage from '@/pages/notification/Notification.vue';

Vue.use(CustomRouter);

export default new CustomRouter({
  // mode: 'history',
  hash: false,
  routes: [
    {
      path: '/',
      component: HomePage
    },
    {
      path: '/init',
      component: InitCompanyPage
    },
    {
      path: '/permission',
      component: PermissionPage
    },
    {
      path: '/profile',
      component: ProfilePage
    },
    {
      path: '/shareholder',
      component: ShareholderPage
    },
    {
      path: '/voting',
      component: VotingPage
    },
    {
      path: '/denied',
      component: AccessDeniedPage
    },
    {
      path: '/error',
      component: ErrorPage
    },
    {
      path: '/financials',
      component: FinancialPage
    },
    {
      path: '/legal',
      component: LegalPage
    },
    {
      path: '/marketplace',
      component: MarketplacePage
    },
    {
      path: '/escrow',
      component: NotificationPage
    }
  ]
});
